import { z } from 'zod/v4'
import { baseEntitySchema } from '../../core/entity.js'

export const userLevel = z.object({
  name: z.string().describe('Name of the level'),
  proficiency: z.number().min(1).describe('Proficiency of the level'),
  description: z.string().describe('Description of the level'),
  minScore: z.number().describe('Minimum score to reach this level'),
  maxScore: z.number().describe('Maximum score in this  level'),
})

export type UserLevel = z.infer<typeof userLevel>

export const userStatsSchema = z.object({
  xp: z.number().describe('Total XP / scores accumulated for the user'),
  level: userLevel.describe('Level of the user'),
  scoreHigh: z.number().describe('Highest score of the user for a game'),
  streak: z.number().min(0).describe('Streak of the user'),
  lastPlayed: z.iso.datetime().describe('Last played date'),
})
export type UserStats = z.infer<typeof userStatsSchema>

export const gameSchema = baseEntitySchema.extend({
  type: z.literal('game'),
  gameId: z.string().describe('Unique type ID of the game'),
  name: z.string().describe('Name of the game'),
  description: z.string().describe('Description of the game'),
  stats: userStatsSchema.optional(),
})
export type Game = z.infer<typeof gameSchema>

/** Results. The games is the parent of the entity */
export const gameResultSchema = baseEntitySchema.extend({
  type: z.literal('gameresult'),

  score: z.number().describe('Score of this game play').optional(),
  nickName: z.string().describe('Nick name of the user to be used in the leaderboard'),
  results: z.record(z.string(), z.unknown()).describe('Spec / results of this game play').optional(),
  createdAt: z.iso.datetime().describe('Date of the game play'),
})
export type GameResult = z.infer<typeof gameResultSchema>

export const gameBoardSchema = baseEntitySchema.extend({
  type: z.literal('gameboard'),
})
export type GameBoard = z.infer<typeof gameBoardSchema>

// /** Zod schema for leaderboard */
// export const leaderBoardScore = z.object({
//   gameId: z.string(),
//   userId: z.string().optional(),
//   cookieId: z.string().optional(),
//   nickName: z.string(),
//   score: z.number(),
//   createdAt: z.iso.datetime(),
// })

// export type LeaderboardScore = z.infer<typeof leaderBoardScore>
